import { AccordionItem } from '../accordion_item';
export interface ManualSetupState {
  accordionItems: Array<AccordionItem>;
}

export const initialManualSetupState: ManualSetupState = {
  accordionItems: []
};

